jQuery(document).ready(function ($) {
    var $bannerEmpreendimento = $('.home-banners-empreendimento .swiper');

    if (!$bannerEmpreendimento.length) return

    var mySwiper = new Swiper('.home-banners-empreendimento .swiper', {
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        speed: 500,
    });
});